import { Warehouse, ExternalLink } from 'lucide-react'
import { WAREHOUSE_PORTAL_URL } from '../../config/warehouse'

/**
 * DEV-49100 — low-emphasis entry point to the AppSheet warehouse
 * ordering portal.
 *
 * Warehouse orders carry handling + transport cost, so this is
 * deliberately de-emphasised: easy to find, never competing with
 * supplier ordering.
 *
 * - variant="row"    full-width row, used at the foot of the home screen
 * - variant="inline" small centred text link, used on job setup
 */
export function WarehousePortalLink({
  variant = 'row',
}: {
  variant?: 'row' | 'inline'
}) {
  if (variant === 'inline') {
    return (
      <a
        href={WAREHOUSE_PORTAL_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 text-gray-400 hover:text-gray-600 text-xs font-medium transition-colors"
      >
        <Warehouse className="w-3.5 h-3.5" />
        Order from our warehouses
      </a>
    )
  }

  return (
    <a
      href={WAREHOUSE_PORTAL_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-2.5 mt-5 pt-4 px-4 border-t border-gray-200 hover:opacity-70 transition-opacity"
    >
      <Warehouse className="w-4 h-4 text-gray-400 flex-shrink-0" />
      <span className="flex-1 min-w-0">
        <span className="block text-gray-600 text-sm font-medium">
          Order from our warehouses
        </span>
        <span className="block text-gray-400 text-xs mt-px">
          For parts suppliers don&rsquo;t stock
        </span>
      </span>
      <ExternalLink className="w-3.5 h-3.5 text-gray-400 flex-shrink-0" />
    </a>
  )
}
